import request from '@/utils/request'

// 官网Pc-二级分类的资源数量
export function thesisCount(data) {
    return request({
        url: `/survey/thesisType/thesisCount`,
        method: 'post',
        data
    })
}
// 官网Pc-品牌研究资源
export function getPcThesisResource(data) {
    return request({
        url: `/survey/thesisResources/getPcThesisResource`,
        method: 'post',
        data
    })
}
// 官网Pc-记录pdf的阅读量
export function pcReadThesis(data) {
    return request({
        url: `/survey/thesisResources/pcReadThesis`,
        method: 'post',
        data
    })
}
// 官网Pc-品牌资源,动态,卓闻团队
export function homePagePc(data) {
    return request({
        url: `/survey/thesisResources/homePagePc`,
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/resourceManage.js